<template>
	<div class="swiper-wrapper">
		<div ref="swiper" class="swiper">
			<div class="swiper-wrapper">
				<slot></slot>
			</div>
		</div>
		<div :class="['swiper-pagination', `swiper-pagination--${id}`, lightBullets && 'light']"></div>
		<button v-show="navigation" type="button" class="swiper-button-prev" aria-label="Prev Slide">
			<svg width="8" height="14" viewBox="0 0 8 14" fill="none">
				<path d="M6.82849 12.6569L1.17163 7.00001C1.17163 7.00001 4.89548 3.27616 6.82847 1.34317" stroke="black" />
			</svg>
		</button>
		<button v-show="navigation" type="button" class="swiper-button-next" aria-label="Next Slide">
			<svg width="8" height="14" viewBox="0 0 8 14" fill="none">
				<path d="M1.17151 1.34314L6.82837 6.99999C6.82837 6.99999 3.10452 10.7238 1.17152 12.6568" stroke="black" />
			</svg>
		</button>
	</div>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.min.css'
export default {
	props: {
		id: {
			type: String,
			default: 'carousel',
		},
		navigation: {
			type: Boolean,
			default: true,
		},
		pagination: {
			type: Boolean,
			default: true,
		},
		mobileOnly: {
			type: Boolean,
			default: false,
		},
		lightBullets: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			slider: null,
			activeIndex: 0,
		}
	},
	mounted() {
		this.slider = new Swiper(this.$refs.swiper, {
			modules: [Pagination, Navigation],
			slidesPerView: 1.2,
			centeredSlides: true,
			spaceBetween: 12,
			breakpoints: {
				600: {
					slidesPerView: this.mobileOnly ? 1 : 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: this.mobileOnly ? 1 : 3,
					spaceBetween: 20,
					loop: true,
				},
			},
			loop: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			uniqueNavElements: false,
			pagination: {
				el: `.swiper-pagination--${this.id}`,
				clickable: true,
				dynamicBullets: true,
			},
			on: {
				slideChange: (swiper) => {
					this.activeIndex = swiper.realIndex
				},
			},
		})
	},
}
</script>

<style lang="scss" scoped>
.swiper-wrapper {
	position: relative;
}
.swiper-slide {
	display: flex;
	justify-content: center;
}
.swiper-button-next,
.swiper-button-prev {
	display: none;
	@media only screen and (min-width: 1024px) {
		display: flex;
	}
	top: unset;
	left: unset;
	bottom: -56px;
	right: 0;
	width: 40px;
	height: 40px;
	background: #ffffff;
	border: 1px solid #dddddd;
	color: #000000;
	&::after {
		content: '';
	}
}
.swiper-button-prev {
	right: 52px;
}
.swiper-pagination {
	bottom: -35px;
	left: 50%;
	transform: translateX(-50%);
}
.swiper-pagination :deep(.swiper-pagination-bullet) {
	background-color: #484848;
}
.swiper-pagination :deep(.swiper-pagination-bullet-active) {
	background-color: #000000;
}
.swiper-pagination.light :deep(.swiper-pagination-bullet) {
	background-color: rgba(255, 255, 255, 0.5);
}
.swiper-pagination.light :deep(.swiper-pagination-bullet-active) {
	background-color: #ffffff;
}
</style>
